import { h } from "preact";
import MiniCartThresholdMessage from "./MiniCartThresholdMessage";

interface MiniCartFooterProps {
  closeDrawer: () => void;
  showMinimumCartThresholdMessage: boolean;
  showViewBasketButton: boolean;
}

function MiniCartFooter({
  closeDrawer,
  showMinimumCartThresholdMessage,
  showViewBasketButton,
}: MiniCartFooterProps) {
  return (
    <form
      className="minicart__footer"
      action={window.themeVars.routes.checkout}
      method="post"
    >
      {showMinimumCartThresholdMessage && <MiniCartThresholdMessage />}

      <div className="minicart__footer-actions">
        {showViewBasketButton && (
          <a href={window.themeVars.routes.cart} className="btn btn-black">
            {window.themeVars.strings.cart.viewBasket}
          </a>
        )}

        <button
          type="button"
          onClick={closeDrawer}
          className="
            minicart__continue-shopping
            btn btn--white
          "
        >
          {window.themeVars.strings.cart.continueShopping}
        </button>
      </div>
    </form>
  );
}

export default MiniCartFooter;
